var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Resumen del proveedor",
          dense: true,
          breadcrumbs: _vm.breadcrumbs,
          breadcrumbsItemDinamic: {
            loading: _vm.$store.state.suppliers.retrieveLoader,
            text: _vm.instance.name,
          },
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _vm.$helpers.hasSomePermission(["view_suppliergroup"]) &&
                _vm.$store?.state?.auth?.account?.suppliergroup_feature
                  ? _c(
                      "v-btn",
                      {
                        attrs: { outlined: "", ripple: false },
                        on: {
                          click: function ($event) {
                            _vm.dialogConfirmLock = true
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v(
                            "mdi-lock" +
                              _vm._s(
                                _vm.currentSegment?.name === "Bloqueados"
                                  ? "-open"
                                  : ""
                              )
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.currentSegment?.name !== "Bloqueados"
                                ? "Bloquear"
                                : "Desbloquear"
                            ) +
                            " proveedor "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-btn",
                  {
                    staticClass: "ml-2",
                    attrs: { color: "grey-900", ripple: false },
                    on: { click: _vm.openEditDialog },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-pencil"),
                    ]),
                    _vm._v(" Editar proveedor "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "pa-0 mt-20", staticStyle: { "z-index": "0" } },
        [
          _vm.loading
            ? _c("skeleton-detail")
            : _c(
                "div",
                { staticClass: "d-flex" },
                [
                  [
                    _c(
                      "div",
                      {
                        staticClass: "mr-6",
                        staticStyle: { "min-width": "400px" },
                      },
                      [
                        _c(
                          "div",
                          { style: _vm.isFixed },
                          [
                            _vm.currentSegment?.name === "Bloqueados"
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "inf-alert-error",
                                    attrs: {
                                      text: "",
                                      outlined: "",
                                      color: "red-500",
                                      rounded: "",
                                      dense: "",
                                      width: 400,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex pa-0 align-center",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "red-500" } },
                                          [_vm._v("mdi-lock")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ml-4 alert-description",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-1 font-weight-bold red-500--text",
                                              },
                                              [_vm._v("Proveedor bloqueado")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block body-2 pb-11 red-500--text",
                                                staticStyle: {
                                                  "line-height": "1.3",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Los documentos de este proveedor son reclamados automaticamente desde el "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-medium",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateTimeSecond"
                                                        )(
                                                          _vm.instance
                                                            ?.group_assigned_date
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "v-card",
                              {
                                staticClass: "grey-900",
                                attrs: { width: "400" },
                              },
                              [
                                _c("v-card-text", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "subtitle-2 white--text font-weight-bold d-inline-block text-truncate",
                                      staticStyle: { "max-width": "90%" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.instance.name) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block subtitle-2 white--text",
                                    },
                                    [_vm._v(_vm._s(_vm.instance.tax_id))]
                                  ),
                                  _c("div", { staticClass: "mt-4" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Actividad económica")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _vm.instance?.business_activity
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.instance
                                                      ?.business_activity
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey-200--text font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "mt-4" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Dirección")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _vm.instance?.address
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.instance.address)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey-200--text font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "mt-4" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Comuna")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _vm.instance?.municipality
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.instance.municipality
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey-200--text font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between",
                                    },
                                    [
                                      _c("div", { staticClass: "mt-4" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block body-1 white--text",
                                          },
                                          [_vm._v("Creado el")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 white--text",
                                          },
                                          [
                                            _vm.instance?.created
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateTimeSecond"
                                                        )(_vm.instance.created)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 grey-200--textfont-italic",
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "mt-4" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block body-1 white--text",
                                          },
                                          [_vm._v("Actualizado el")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 white--text",
                                          },
                                          [
                                            _vm.instance?.updated
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateTimeSecond"
                                                        )(_vm.instance.updated)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 grey-200--text font-italic",
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm.$store?.state?.auth?.account?.options?.includes(
                              "rec_process_rules"
                            )
                              ? _c(
                                  "v-card",
                                  {
                                    staticClass: "pa-0 mt-4",
                                    attrs: {
                                      width: "400",
                                      transition: "slide-y-transition",
                                      flat: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-toolbar",
                                      {
                                        attrs: {
                                          color: "transparent",
                                          flat: "",
                                          height: "46",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          {
                                            staticClass:
                                              "px-5 subtitle-2 grey-500--text font-weight-bold d-flex align-center",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "18",
                                                  left: "",
                                                  color: "grey-500",
                                                },
                                              },
                                              [_vm._v("mdi-folder")]
                                            ),
                                            _vm._v(" Categoría "),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c(
                                      "v-card-text",
                                      { staticClass: "py-2 px-5" },
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticClass:
                                              "v-list-form-main transparent pa-0",
                                          },
                                          [
                                            _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  { staticClass: "mr-4" },
                                                  [
                                                    _c(
                                                      "v-avatar",
                                                      {
                                                        attrs: {
                                                          color:
                                                            _vm.isDefaultCategory
                                                              ? "yellow-100"
                                                              : "green-100",
                                                          size: 28,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color:
                                                                _vm.isDefaultCategory
                                                                  ? "yellow-500"
                                                                  : "green-500",
                                                              size: 16,
                                                            },
                                                          },
                                                          [_vm._v("mdi-folder")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.$store.state.suppliers
                                                  .retrieveLoader
                                                  ? _c("v-avatar", {
                                                      staticClass:
                                                        "placeholder rounded-pill",
                                                      attrs: {
                                                        tile: "",
                                                        height: "15",
                                                        width: "300",
                                                      },
                                                    })
                                                  : _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "grey-500--text body-1 font-weight-semibold d-inline-block text-truncate",
                                                        staticStyle: {
                                                          "max-width": "90%",
                                                        },
                                                      },
                                                      [
                                                        _vm.currentSegment
                                                          ?.name ===
                                                        "Bloqueados"
                                                          ? _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "font-weight-semibold",
                                                                attrs: {
                                                                  color:
                                                                    "greyMedium",
                                                                  small: "",
                                                                  label: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Bloqueados"
                                                                ),
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      right: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-lock"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm.currentSegment
                                                              ?.id
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "text-decoration-none grey-900--text",
                                                                attrs: {
                                                                  to: {
                                                                    name: "SuppliersCategoriesRetrieveUpdate",
                                                                    params: {
                                                                      id: _vm
                                                                        .currentSegment
                                                                        .id,
                                                                      ..._vm.currentParams,
                                                                    },
                                                                  },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .currentSegment
                                                                      .name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "text-decoration-none grey-500--text",
                                                                attrs: {
                                                                  to: {
                                                                    name: "SuppliersCategoriesRetrieveUpdate",
                                                                    params: {
                                                                      id: "se_AAAAAAAAAAAAAAAA",
                                                                      ..._vm.currentParams,
                                                                    },
                                                                  },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Sin categoría asociada"
                                                                ),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                _c(
                                                  "v-list-item-action",
                                                  [
                                                    _c(
                                                      "v-menu",
                                                      {
                                                        attrs: {
                                                          "close-on-click": "",
                                                          "close-on-content-click":
                                                            "",
                                                          "offset-y": "",
                                                          left: "",
                                                          "nudge-bottom": 10,
                                                          "nudge-left": 10,
                                                          transition:
                                                            "slide-y-transition",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "mr-n4",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                [
                                                                                  "Bloqueados",
                                                                                ].includes(
                                                                                  _vm
                                                                                    .currentSegment
                                                                                    ?.name
                                                                                ),
                                                                              text: "",
                                                                              "x-small":
                                                                                "",
                                                                            },
                                                                        },
                                                                        "v-btn",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey-500",
                                                                              size: "24",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-dots-vertical"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          4012010532
                                                        ),
                                                      },
                                                      [
                                                        _c(
                                                          "v-list",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _vm.instance
                                                              .segment_id &&
                                                            _vm.instance
                                                              .segment_id
                                                              .length > 0 &&
                                                            _vm.instance
                                                              .segment_id !==
                                                              "se_AAAAAAAAAAAAAAAA"
                                                              ? _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "px-3",
                                                                    attrs: {
                                                                      ripple: false,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.handleDelete,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 d-flex align-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "grey-500",
                                                                                size: "16",
                                                                                left: "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-folder-minus"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "Eliminar de la categoría "
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            !_vm.instance
                                                              .segment_id ||
                                                            _vm.instance
                                                              .segment_id
                                                              .length === 0 ||
                                                            _vm.instance
                                                              .segment_id ===
                                                              "se_AAAAAAAAAAAAAAAA"
                                                              ? _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "px-3",
                                                                    attrs: {
                                                                      ripple: false,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.handleAdd,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 d-flex align-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "grey-500",
                                                                                size: "16",
                                                                                left: "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-folder-plus"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "Agregar a categoría "
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm.instance
                                                              .segment_id &&
                                                            _vm.instance
                                                              .segment_id
                                                              .length > 0 &&
                                                            _vm.instance
                                                              .segment_id !==
                                                              "se_AAAAAAAAAAAAAAAA"
                                                              ? _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "px-3",
                                                                    attrs: {
                                                                      ripple: false,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.handleChange,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 d-flex align-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "grey-500",
                                                                                size: "16",
                                                                                left: "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-swap-horizontal"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "Cambiar de categoría "
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.$store?.state?.auth?.account?.options?.includes(
                              "rec_process_rules"
                            ) &&
                            _vm.currentSegment?.automatization_name &&
                            _vm.currentSegment?.automatization_action
                              ? _c(
                                  "v-card",
                                  {
                                    staticClass: "pa-0 mt-4",
                                    attrs: {
                                      width: "400",
                                      transition: "slide-y-transition",
                                      flat: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-toolbar",
                                      {
                                        attrs: {
                                          color: "transparent",
                                          flat: "",
                                          height: "46",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          {
                                            staticClass:
                                              "px-5 subtitle-2 grey-500--text font-weight-bold d-flex align-center",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "18",
                                                  left: "",
                                                  color: "grey-500",
                                                },
                                              },
                                              [_vm._v("mdi-flash")]
                                            ),
                                            _vm._v(" Automatización "),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c(
                                      "v-card-text",
                                      { staticClass: "py-5 px-5" },
                                      [
                                        _vm.$helpers.hasSomePermission([
                                          "view_suppliergroup",
                                        ]) &&
                                        _vm.$store?.state?.auth?.account
                                          ?.suppliergroup_feature
                                          ? _c(
                                              "v-list",
                                              {
                                                staticClass:
                                                  "v-list-form-main transparent pa-0",
                                                attrs: { "three-line": "" },
                                              },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  { staticClass: "pa-0" },
                                                  [
                                                    _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "grey-500--text body-1 font-weight-semibold",
                                                      },
                                                      [
                                                        _vm.currentSegment
                                                          ?.automatization_name
                                                          ? [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .currentSegment
                                                                    ?.automatization_name
                                                                )
                                                              ),
                                                            ]
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "body-2 text--disabled font-italic",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Sin especificar"
                                                                ),
                                                              ]
                                                            ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.currentSegment
                                          ?.automatization_action
                                          ? _c(
                                              "div",
                                              { staticClass: "mt-3" },
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "font-weight-semibold",
                                                    attrs: {
                                                      color:
                                                        _vm.statusChip[
                                                          _vm.currentSegment?.automatization_action?.toLowerCase()
                                                        ]?.color,
                                                      small: "",
                                                      label: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.statusChip[
                                                          _vm.currentSegment?.automatization_action?.toLowerCase()
                                                        ]?.key
                                                      )
                                                    ),
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { right: "" } },
                                                      [
                                                        _vm._v(
                                                          "mdi-" +
                                                            _vm._s(
                                                              _vm.statusChip[
                                                                _vm.currentSegment?.automatization_action?.toLowerCase()
                                                              ]?.icon
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mb-8",
                        staticStyle: { flex: "1", "min-width": "200px" },
                      },
                      [
                        _c(
                          "v-card",
                          { attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-text",
                              { staticClass: "pa-0" },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c("v-col", { staticClass: "px-5 py-4" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-500--text font-weight-bold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "18",
                                                left: "",
                                                color: "grey-500",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "mdi-file-document-multiple"
                                              ),
                                            ]
                                          ),
                                          _vm._v("Documentos recibidos"),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("v-divider"),
                                _c("purchase-list", {
                                  attrs: {
                                    loading: _vm.purchaseLoading,
                                    "show-pagination": false,
                                  },
                                }),
                                _vm.purchasesList?.length
                                  ? [
                                      _c("v-divider"),
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "px-4 pt-4 pb-2",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-5 body-1",
                                              attrs: {
                                                to: {
                                                  name: "PurchaseList",
                                                  params: _vm.$route.params,
                                                  query: {
                                                    tax_id: _vm.cleanTaxId,
                                                  },
                                                },
                                                ripple: false,
                                                text: "",
                                                color: "grey-900",
                                              },
                                            },
                                            [_vm._v("Ver todos los documentos")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm.$store?.state?.auth?.account?.options?.includes(
                          "pending_documents"
                        )
                          ? _c(
                              "v-card",
                              { staticClass: "mt-6", attrs: { flat: "" } },
                              [
                                _c(
                                  "v-card-text",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "px-5 py-4" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey-500--text font-weight-bold",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "18",
                                                      left: "",
                                                      color: "grey-500",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-file-document-multiple"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "Documentos pendientes de recibir"
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c("purchase-pending-list", {
                                      attrs: {
                                        loading: _vm.siiLoading,
                                        "show-pagination": false,
                                      },
                                    }),
                                    _vm.purchasesSiiList?.length
                                      ? [
                                          _c("v-divider"),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "px-4 pt-4 pb-2",
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ml-5 body-1",
                                                  attrs: {
                                                    to: {
                                                      name: "PendingReceiveList",
                                                      query: {
                                                        tax_id: _vm.cleanTaxId,
                                                      },
                                                    },
                                                    ripple: false,
                                                    text: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Ver todos los documentos"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "838",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogConfirmLock,
            callback: function ($$v) {
              _vm.dialogConfirmLock = $$v
            },
            expression: "dialogConfirmLock",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.currentSegment?.name !== "Bloqueados"
                                ? "Bloquear"
                                : "Desbloquear"
                            ) + " proveedor"
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogConfirmLock = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-el-lock.svg`),
                            width: 178,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 body-1 pl-6" },
                        [
                          _vm.currentSegment?.name !== "Bloqueados"
                            ? [
                                _vm._v(
                                  " Al bloquear el proveedor todos los nuevos documentos seran reclamadas automaticamente. "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "d-block body-1 pt-3" },
                                  [
                                    _vm._v(
                                      "Puedes desbloquear al proveedor y asignarlo a cualquier categoria cuando lo desees."
                                    ),
                                  ]
                                ),
                              ]
                            : _c(
                                "span",
                                { staticClass: "d-block body-1 pt-3" },
                                [
                                  _vm._v(
                                    "Al desbloquear el proveedor no tendra categorias asociadas y estara sujeto a las reglas de automatizacion para proveedores sin categorias. Podra ser asignado a otras categorias en el futuro."
                                  ),
                                ]
                              ),
                          _c(
                            "span",
                            { staticClass: "d-block body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v('"confirmar"'),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                _vm.confirm.toLowerCase() === "confirmar" &&
                                  ((_vm.dialogConfirmLock = false),
                                  _vm.toggleBlock())
                              },
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogConfirmLock = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.$store.state.irs.createLoader,
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogConfirmLock = false), _vm.toggleBlock()
                        },
                      },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$store?.state?.auth?.account?.options?.includes("rec_process_rules")
        ? _c("SupplierDeleteCategoryModal", {
            attrs: { supplier: _vm.instance },
            on: { confirm: _vm.handleDeleteConfirm },
            model: {
              value: _vm.dialogDelete,
              callback: function ($$v) {
                _vm.dialogDelete = $$v
              },
              expression: "dialogDelete",
            },
          })
        : _vm._e(),
      _vm.$store?.state?.auth?.account?.options?.includes("rec_process_rules")
        ? _c("SupplierCategoryModal", {
            attrs: {
              "action-type": _vm.actionType,
              supplier: _vm.instance,
              "categories-list": _vm.segmentsList,
              loading: _vm.createCategoryLoading,
            },
            on: { confirm: _vm.handleCategoryConfirm },
            model: {
              value: _vm.dialogAddCategory,
              callback: function ($$v) {
                _vm.dialogAddCategory = $$v
              },
              expression: "dialogAddCategory",
            },
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogSupplier,
            callback: function ($$v) {
              _vm.dialogSupplier = $$v
            },
            expression: "dialogSupplier",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Editar proveedor")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogSupplier = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "py-4 px-0 overflow-y-auto",
                  staticStyle: { "max-height": "710px" },
                  attrs: { "min-height": "700", scrollable: "" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "font-weight-bold d-flex align-center body-1 px-5 pt-0 text-500--text",
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "grey-500", size: "18", left: "" } },
                        [_vm._v("mdi-human-dolly")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Información del proveedor")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "3" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                          ]),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "dni",
                                rawName: "v-dni",
                                value:
                                  _vm.$store?.state?.auth?.account?.country,
                                expression:
                                  "$store?.state?.auth?.account?.country",
                              },
                            ],
                            attrs: {
                              readonly: "",
                              disabled: "",
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.editable.tax_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.editable, "tax_id", $$v)
                              },
                              expression: "editable.tax_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Nombre de la empresa"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.editable.name.$error,
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "100",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.editable.name.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.editable.name,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.editable.name.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-5" },
                    [
                      _c("span", { staticClass: "grey-500--text body-1" }, [
                        _vm._v("Actividad económica"),
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          "single-line": "",
                          dense: "",
                          maxlength: "64",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.editable.business_activity,
                          callback: function ($$v) {
                            _vm.$set(_vm.editable, "business_activity", $$v)
                          },
                          expression: "editable.business_activity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5 pb-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "8" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Dirección"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "64",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.editable.address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editable,
                                  "address",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editable.address",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pa-0 ml-3" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v(_vm._s(_vm.$t("generals.Comuna"))),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "64",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.editable.municipality,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editable,
                                  "municipality",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editable.municipality",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "px-5 pt-3", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Ciudad"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              maxlength: "64",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.editable.city,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editable,
                                  "city",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editable.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.$store?.state?.auth?.account?.options?.includes(
                    "rec_process_rules"
                  )
                    ? [
                        _c("v-divider", { staticClass: "my-4" }),
                        _c(
                          "div",
                          { staticClass: "px-5 py-1" },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-0 mb-3 subtitle-2 grey-500--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-500",
                                      size: "18",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-account-multiple")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "subtitle-2 grey-500--text font-weight-semibold",
                                  },
                                  [
                                    _vm._v(
                                      "Selecciona la categoría a la que quieres asignar al proveedor"
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass:
                                      "ml-2 px-1 font-weight-regular",
                                    attrs: {
                                      "x-small": "",
                                      color: "grey-background",
                                    },
                                  },
                                  [_vm._v("Opcional")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "pa-0" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "grey-500--text body-1" },
                                  [_vm._v("Categorías")]
                                ),
                                _c(
                                  "v-col",
                                  { staticClass: "pa-0" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        "hide-details": "",
                                        "single-line": "",
                                        color: "green-500",
                                        dense: "",
                                        outlined: "",
                                        clearable: "",
                                        items: _vm.filteredSegmentsListForEdit,
                                        chips: false,
                                        "item-text": "name",
                                        "item-value": "id",
                                        "item-disabled": "disabled",
                                        "no-data-text":
                                          "No existen categorías para mostrar",
                                        "menu-props": {
                                          bottom: true,
                                          offsetY: true,
                                          maxHeight: 200,
                                        },
                                      },
                                      model: {
                                        value: _vm.editable.segment_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.editable,
                                            "segment_id",
                                            $$v
                                          )
                                        },
                                        expression: "editable.segment_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogSupplier = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.$store.state.suppliers.createLoader,
                      },
                      on: { click: _vm.updateSupplier },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }